import { useQuery } from '@tanstack/react-query';
import { booksManageService } from '../api/booksManageService';
import type { BookDto } from '../types/book';

export function useBookQuery(id: string | null | undefined) {
  return useQuery<BookDto>({
    queryKey: ['manage-book', id],
    queryFn: () => booksManageService.get(id!),
    enabled: !!id,
    staleTime: 0,
  });
}
